import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * pipe to highlight information in string.
 * Usage :  <span [innerHTML]="'monster munch'|highlight:'ter mun'"></span>
 * Output: <span>mons<em class="highlight">ter mun</em>ch</span>
 * Style is defined in main styles.sass
 */

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) {
  }

  transform(value: string, search?: string): any {
    if (!search) {
      return value;
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(value.replace(new RegExp(`(${search})`, 'ig'),  '<em class="highlight">$1</em>'));
    }
  }

}
